<ng-template #iconMenu>
    <div id="navbar-icon-menu" [ngClass]="{ evenly: isNavbarNavVertical, 'in-menu': iconsMovedToMenu }">
        <jhi-theme-switch [popoverPlacement]="iconsMovedToMenu ? 'bottom' : 'bottom-right'" />
        @if (isAuthenticated()) {
            <div
                ngbDropdown
                class="dropdown pointer"
                display="dynamic"
                [placement]="'bottom-right'"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [autoClose]="true"
            >
                <a class="nav-link dropdown-toggle" ngbDropdownToggle id="account-menu">
                    @if (!getImageUrl()) {
                        <span>
                            <fa-icon [icon]="faUser" />
                            @if (!currAccount) {
                                <span jhiTranslate="global.menu.account.main"></span>
                            }
                            @if (currAccount) {
                                <span>{{ currAccount.login }}</span>
                            }
                        </span>
                    }
                    @if (getImageUrl()) {
                        <span>
                            <img [src]="getImageUrl()" class="profile-image img-circle rounded-3" alt="Avatar" />
                        </span>
                    }
                </a>
                <ul class="dropdown-menu dropdown-menu-index" ngbDropdownMenu>
                    <li>
                        <a class="dropdown-item" [routerLink]="['/user-settings']" (click)="collapseNavbar()">
                            <fa-icon [icon]="faCog" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.settings"></span>
                        </a>
                    </li>
                    <div class="dropdown-divider"></div>
                    <li>
                        <h6 class="dropdown-header fw-medium" jhiTranslate="global.menu.language"></h6>
                    </li>
                    @if (languages && languages.length > 1) {
                        <div>
                            @for (language of languages; track language) {
                                <li>
                                    <a class="dropdown-item" [jhiActiveMenu]="language" (click)="changeLanguage(language); collapseNavbar()">{{
                                        language | findLanguageFromKey
                                    }}</a>
                                </li>
                            }
                        </div>
                    }
                    <div class="dropdown-divider"></div>
                    @if (isRegistrationEnabled) {
                        <li>
                            <a class="dropdown-item" routerLink="/account/settings" routerLinkActive="active" (click)="collapseNavbar()">
                                <fa-icon [icon]="faWrench" [fixedWidth]="true" />
                                <span jhiTranslate="global.menu.account.settings"></span>
                            </a>
                        </li>
                    }
                    @if (passwordResetEnabled) {
                        <li>
                            <a class="dropdown-item" routerLink="/account/password" routerLinkActive="active" (click)="collapseNavbar()">
                                <fa-icon [icon]="faLock" [fixedWidth]="true" />
                                <span jhiTranslate="global.menu.account.password"></span>
                            </a>
                        </li>
                    }
                    <li>
                        @if (currAccount) {
                            <a class="dropdown-item" (click)="logout()" id="logout">
                                <fa-icon [icon]="faSignOutAlt" [fixedWidth]="true" />
                                <span jhiTranslate="global.menu.account.logout"></span>
                            </a>
                        }
                    </li>
                </ul>
            </div>
        }
    </div>
</ng-template>
<nav class="navbar jh-navbar" [class.expanded]="!isCollapsed">
    <div class="jh-logo-container">
        <a class="navbar-brand" routerLink="/" (click)="collapseNavbar()">
            <img [src]="'public/images/logo.png'" height="30" alt="" />
            <div jhiTranslate="global.title" class="navbar-title"></div>
            <ng-template #gitInfo>
                <div>
                    {{ 'artemisApp.git.branch' | artemisTranslate }}: {{ gitBranchName }} <br />
                    {{ 'artemisApp.git.commit' | artemisTranslate }}: {{ gitCommitId }} <br />
                    {{ 'artemisApp.git.timestamp' | artemisTranslate }}: {{ gitTimestamp }} <br />
                    {{ 'artemisApp.git.username' | artemisTranslate }}: {{ gitUsername }}
                </div>
            </ng-template>
            <div class="navbar-version" placement="bottom" [ngbTooltip]="gitInfo" tooltipClass="git-info" [disableTooltip]="inProduction && !testServer">
                {{ version }}
            </div>
        </a>
        <div class="indicators">
            <jhi-connection-warning class="align-self-center" />
            <jhi-loading-notification class="align-self-center" />
        </div>
        @if (!iconsMovedToMenu && isCollapsed) {
            <ng-container *ngTemplateOutlet="iconMenu" />
        }
        <div class="toggler-wrapper">
            <a
                class="toggler"
                data-toggle="collapse"
                data-target="#navbarResponsive"
                aria-controls="navbarResponsive"
                aria-expanded="false"
                aria-label="Toggle navigation"
                (click)="toggleNavbar()"
            >
                <fa-icon [icon]="faBars" />
            </a>
        </div>
    </div>
    <div class="navbar-collapse collapse" id="navbarResponsive" [ngbCollapse]="isNavbarCollapsed">
        <ul class="navbar-nav ms-auto" [class.vertical]="isNavbarNavVertical">
            @if (currAccount && !isExamActive && !isExamStarted) {
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="nav-link py-0" routerLink="/courses" (click)="collapseNavbar()" id="overview-menu">
                        <span>
                            <fa-icon [icon]="faThLarge" />
                            <span jhiTranslate="global.menu.overview"></span>
                        </span>
                    </a>
                </li>
            }
            <li
                *jhiHasAnyAuthority="['ROLE_TA', 'ROLE_EDITOR', 'ROLE_INSTRUCTOR', 'ROLE_ADMIN']"
                ngbDropdown
                class="nav-item dropdown pointer"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
            >
                @if (!isExamActive && !isExamStarted) {
                    <a class="nav-link py-0" routerLink="/course-management" (click)="collapseNavbar()" id="course-admin-menu">
                        <span>
                            <fa-icon [icon]="faThList" />
                            <span jhiTranslate="global.menu.course"></span>
                        </span>
                    </a>
                }
            </li>
            <li
                *jhiHasAnyAuthority="'ROLE_ADMIN'"
                ngbDropdown
                class="nav-item dropdown pointer"
                display="dynamic"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
            >
                @if (!isExamActive && !isExamStarted) {
                    <a class="nav-link dropdown-toggle py-0" ngbDropdownToggle id="admin-menu">
                        <span>
                            <fa-icon [icon]="faUserPlus" />
                            <span jhiTranslate="global.menu.admin.main"></span>
                        </span>
                    </a>
                }
                <ul class="dropdown-menu dropdown-menu-index" ngbDropdownMenu>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/upcoming-exams-and-exercises" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faBookOpen" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.upcomingExamsAndExercises"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/user-management" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faUser" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.userManagement"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/organization-management" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faUniversity" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.organizationManagement"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/system-notification-management" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faBell" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.systemNotifications"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/feature-toggles" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faToggleOn" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.featureToggles"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/user-statistics" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faEye" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.statistics"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/metrics" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faTachometerAlt" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.metrics"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/privacy-statement" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faLock" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.privacyStatement"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/imprint" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faStamp" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.imprint"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/health" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faHeart" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.health"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/configuration" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faList" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.configuration"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/audits" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faBell" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.audits"></span>
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item" routerLink="/admin/logs" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faTasks" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.logs"></span>
                        </a>
                    </li>
                    @if (localCIActive) {
                        <li>
                            <a class="dropdown-item" routerLink="/admin/build-queue" routerLinkActive="active" (click)="collapseNavbar()">
                                <fa-icon [icon]="faList" [fixedWidth]="true" />
                                <span jhiTranslate="artemisApp.buildQueue.title"></span>
                            </a>
                        </li>
                    }
                    @if (localCIActive) {
                        <li>
                            <a class="dropdown-item" routerLink="/admin/build-agents" routerLinkActive="active" (click)="collapseNavbar()">
                                <fa-icon [icon]="faGears" [fixedWidth]="true" />
                                <span jhiTranslate="artemisApp.buildAgents.title"></span>
                            </a>
                        </li>
                    }
                    @if (irisEnabled) {
                        <li>
                            <a class="dropdown-item" routerLink="/admin/iris" routerLinkActive="active" (click)="collapseNavbar()">
                                <fa-icon [icon]="faRobot" [fixedWidth]="true" />
                                <span jhiTranslate="global.menu.admin.iris"></span>
                            </a>
                        </li>
                    }
                    @if (ltiEnabled) {
                        <a class="dropdown-item" routerLink="/admin/lti-configuration" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faPuzzlePiece" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.lti"></span>
                        </a>
                    }
                    @if (standardizedCompetenciesEnabled) {
                        <jhi-feature-overlay [enabled]="atlasEnabled">
                            <li>
                                <a class="dropdown-item" routerLink="/admin/standardized-competencies" routerLinkActive="active" (click)="collapseNavbar()">
                                    <fa-icon [icon]="faFlag" [fixedWidth]="true" />
                                    <span jhiTranslate="global.menu.admin.standardizedCompetencies"></span>
                                </a>
                            </li>
                        </jhi-feature-overlay>
                    }
                    <li>
                        <a class="dropdown-item" routerLink="/admin/cleanup-service" routerLinkActive="active" (click)="collapseNavbar()">
                            <fa-icon [icon]="faBroom" [fixedWidth]="true" />
                            <span jhiTranslate="global.menu.admin.cleanupService"></span>
                        </a>
                    </li>
                </ul>
            </li>
            @if (!currAccount && languages && languages.length > 1) {
                <li ngbDropdown class="nav-item dropdown pointer" display="dynamic">
                    <a class="nav-link dropdown-toggle" ngbDropdownToggle id="languagesnavBarDropdown">
                        <span>
                            <fa-icon [icon]="faFlag" />
                            <span jhiTranslate="global.menu.language"></span>
                        </span>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu>
                        @for (language of languages; track language) {
                            <li>
                                <a class="dropdown-item" [jhiActiveMenu]="language" (click)="changeLanguage(language); collapseNavbar()">{{ language | findLanguageFromKey }}</a>
                            </li>
                        }
                    </ul>
                </li>
            }
        </ul>
        @if (!isCollapsed || iconsMovedToMenu) {
            <ng-container *ngTemplateOutlet="iconMenu" />
        }
    </div>
</nav>
<jhi-system-notification />
<div class="breadcrumb-container">
    @if (!isExamStarted && !isExamActive && breadcrumbs && breadcrumbs.length > 0) {
        <div>
            <ol class="breadcrumb">
                @for (breadcrumb of breadcrumbs; track breadcrumb.label; let i = $index) {
                    @if (i !== 0) {
                        <fa-icon [icon]="faChevronRight" size="xs" class="breadcrumb-divider mx-2" />
                    }
                    <li class="breadcrumb-item">
                        @if (breadcrumb && breadcrumb.translate) {
                            <a
                                class="breadcrumb-link"
                                id="bread-crumb-{{ i }}"
                                [routerLink]="breadcrumb.uri"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                >{{ breadcrumb.label | artemisTranslate }}</a
                            >
                        }
                        @if (breadcrumb && !breadcrumb.translate) {
                            @if (isBuildAgentDetails) {
                                <a
                                    class="breadcrumb-link"
                                    id="bread-crumb-{{ i }}"
                                    [routerLink]="breadcrumb.uri"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    [queryParams]="{ agentName: agentName }"
                                    >{{ breadcrumb.label }}</a
                                >
                            } @else {
                                <a
                                    class="breadcrumb-link"
                                    id="bread-crumb-plain-{{ i }}"
                                    [routerLink]="breadcrumb.uri"
                                    routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }"
                                    >{{ breadcrumb.label }}</a
                                >
                            }
                        }
                    </li>
                }
            </ol>
        </div>
    }
</div>
